export const STATUS_COLORS = {
  DRAFT: '#64748b',
  VALIDATED: '#0369a1',
  PUBLISHED: '#15803d',
  ACTIVE: '#166534',
  SUPERSEDED: '#a16207',
};

export const emptyField = (sectionCode = 'WORK_VALUE') => ({
  fieldCode: '',
  fieldLabel: '',
  sectionCode,
  sequence: 0,
  dataType: 'AMOUNT',
  fieldType: 'INPUT',
  sourceType: 'MANUAL',
  semanticRole: '',
  formulaJson: null,
  editable: true,
  visible: true,
  printVisible: true,
  allowOverride: false,
  status: 'ACTIVE',
  required: false,
  roundingMethod: 'ROUND',
  decimalPlaces: 0,
  metadata: null,
});
